export { default as PacasAlCorte } from "./PacasAlCorte";
